import { render, staticRenderFns } from "./createRateForm.vue?vue&type=template&id=204004a3"
import script from "./createRateForm.vue?vue&type=script&lang=js"
export * from "./createRateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports